import { z } from 'zod';

/**
 * Calculation modes determine how metric data is calculated and displayed in explore columns.
 */
export enum CalculationMode {
  /**
   * Represents the absolute count or sum of the metric.
   */
  TOTAL = 'TOTAL',

  /**
   * Represents the normalized value of the metric per minute of player activity.
   */
  INTENSITY = 'INTENSITY',

  /**
   * Represents the percentage of successful attempts (e.g., shots made vs. shots taken).
   */
  PERCENTAGE = 'PERCENTAGE',
}

export const calculationModeSchema = z.enum(CalculationMode);

/**
 * Checks if the given value is a valid CalculationMode.
 *
 * @param value - The value to check.
 * @returns True if the value is a CalculationMode, false otherwise.
 */
export function isCalculationMode(value: unknown): value is CalculationMode {
  return calculationModeSchema.safeParse(value).success;
}
